module.exports = __webpack_public_path__ + "img/comingsoon.aca12f92.png";